(function () {

  'use strict';

  angular
    .module('eclipseApp.core')
    .directive('fidoConfirmPasswordCriteria', fidoConfirmPasswordCriteria);

  fidoConfirmPasswordCriteria.$inject = ['$compile', '$templateRequest'];

  function fidoConfirmPasswordCriteria($compile, $templateRequest) {
    return {
      restrict: 'AE',
      require: 'ngModel',
      scope: {
        config: '=fidoConfirmPasswordCriteria'
      },
      link: function ($scope, $element, $attrs, ngModel) {
        var clearWatch;

        $scope.validation = {
          isMatched: false
        };

        $templateRequest('modules/core/password-criteria/confirm-password-criteria.view.html')
          .then(function (html) {
            var template = angular.element(html);
            $(template).insertAfter($element);
            $compile(template)($scope);

            $element.on('keyup', onKeyUpConfirmHandler);
            clearWatch = $scope.$watch('config.passwordValue', function (newVal, oldVal) {
              if ($element.val() && newVal && newVal !== oldVal) {
                checkPasswordMatched($element.val());
              }
            });
          });

        $scope.$on('$destroy', function () {
          $element.off('keyup', onKeyUpConfirmHandler);
          clearWatch();
        });

        function onKeyUpConfirmHandler(e) {
          $scope.$applyAsync(function () {
            var confirmedPassword = e.target.value;
            checkPasswordMatched(confirmedPassword) ;
          });
        }

        function checkPasswordMatched (confirmedPassword){
          if (confirmedPassword !== $scope.config.passwordValue) {
            $scope.validation.isMatched = false;
            ngModel.$setValidity('match', false);
          } else {
            $scope.validation.isMatched = true;
            ngModel.$setValidity('match', true);
          }
        }
      }
    };
  }
})();
